export const state = {
  actionToken: null,
  dialogPending: false,
  dialogIsOpen: false,
  dialogIframeUrl: null,
  dialogError: null,
  dialogSuccess: null,
}
